<template>
    <div class="alibaba-report">
        <div class="main-button-bar">
            <el-date-picker
                type="date"
                placeholder="统计时间（开始）"
                v-model="condition.reportDateStart"
                class="search-item"
                value-format="yyyy-MM-dd"
            ></el-date-picker>

            <el-date-picker
                type="date"
                placeholder="统计时间（截止）"
                v-model="condition.reportDateEnd"
                class="search-item"
                value-format="yyyy-MM-dd"
            ></el-date-picker>

            <el-button type="primary" size="small" @click="SearchBycondition()">搜索</el-button>

            <el-button
                class="add-button"
                type="success"
                plain
                icon="el-icon-plus"
                size="small"
                @click="showAddDialog"
                title="新建日报"
            ></el-button>
        </div>

        <div
            :style="'height:' + (this.$tools.mainHeight() - 61) + 'px;'"
            v-infinite-scroll="next"
            :infinite-scroll-disabled="disabled()"
            infinite-scroll-delay="1000"
            class="daily-box"
        >
            <el-card class="daily-item box-card" v-for="(item, i) in records" :key="i">
                <div class="daily-title">
                    <span>{{item.userName}} {{$tools.timestampToDay(item.reportDate)}} 日报</span>

                    <el-button
                        v-if="item.canEdit == 'Y'"
                        title="编辑日报"
                        class="edit-button"
                        icon="el-icon-edit"
                        circle
                        size="mini"
                        @click="showEditDialog(item.id, item.reportDate, item.content)"
                    ></el-button>

                    <el-button
                        v-if="item.canEdit == 'Y'"
                        title="删除日报"
                        class="edit-button"
                        icon="el-icon-delete"
                        circle
                        size="mini"
                        @click="deleteReport(item.id)"
                    ></el-button>
                </div>
                <pre class="daily-content">{{item.content}}</pre>
                <div class="daily-createTime">{{$tools.timestampToTime(item.createTime)}} 创建</div>
            </el-card>

            <div class="daily-more">
                <p v-if="!disabled()">加载中....</p>
                <p v-if="disabled()">没有更多了...</p>
            </div>
        </div>

        <el-dialog
            :title="report.id ? '编辑日报' : '新建日报'"
            :visible.sync="showDialog"
            width="700px"
            @closed="refeshRule"
        >
            <el-form
                :model="report"
                :rules="rules"
                label-width="80px"
                label-position="left"
                ref="reportForm"
            >
                <el-form-item label="填报日期" prop="reportDate">
                    <el-date-picker type="date" v-model="report.reportDate" style="width: 100%"></el-date-picker>
                </el-form-item>

                <el-form-item label="日报描述" prop="content">
                    <el-input type="textarea" v-model="report.content" rows="9"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="showDialog = false">取消</el-button>
                <el-button type="primary" size="small" @click="chechRule">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import SnUserSearchInput from "../components/SnUserSearchInput.vue";
export default {
    components: { SnUserSearchInput },
    data() {
        return {
            params: {},
            showDialog: false,
            records: [],
            condition: {},
            report: {},
            rules: {
                content: [
                    {
                        required: true,
                        message: "请输入任务描述",
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        max: 2048,
                        message: "长度在 2 到 2048 个字符",
                        trigger: "blur",
                    },
                ],
                reportDate: [
                    {
                        required: true,
                        message: "请选择填报日期",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        disabled() {
            return (
                this.params.current >= this.params.pages ||
                this.params.total == 0
            );
        },
        next() {
            this.params.current =
                (this.params.current ? this.params.current : 0) + 1;
            this.search();
        },
        search() {
            let _this = this;

            _this.$http.post(
                ["daily/mypage", _this.params, _this.condition],
                [
                    function (data) {
                        _this.params.pages = data.pages;
                        _this.params.total = data.total;
                        _this.records = _this.records.concat(data.records);
                    },
                    function () {
                        _this.params.total = 0;
                    },
                ],
                ".daily-box"
            );
        },
        SearchBycondition() {
            this.records = [];
            this.search();
        },
        showAddDialog() {
            this.report = {};
            this.showDialog = true;
        },
        showEditDialog(id, reportDate, content) {
            this.report = {
                id: id,
                reportDate: this.$tools.timestampToDay(reportDate),
                content: content,
            };

            this.showDialog = true;
        },
        chechRule() {
            this.$refs["reportForm"].validate().then(this.doUpdate);
        },
        doUpdate() {
            let _this = this;

            _this.$http.post(
                ["daily/update", _this.report],
                [
                    function (page) {
                        _this.showDialog = false;
                        _this.SearchBycondition();
                    },
                ],
                ".dialog-footer"
            );
        },
        deleteReport(id) {
            let _this = this;

            _this.report.id = id;

            _this.$tConfirm.show("确认删除？", function () {
                _this.$http.post(
                    ["daily/delete", _this.report],
                    [
                        function (page) {
                            _this.showDialog = false;
                            _this.SearchBycondition();
                        },
                    ],
                    ".dialog-footer"
                );
            });
        },
        refeshRule() {
            this.$refs["reportForm"].resetFields();
        },
    },
};
</script>

<style lang="scss">
.daily-box {
    overflow-y: auto;

    .daily-item {
        float: left;
        margin: 1%;
        width: 31%;
    }

    .daily-more {
        clear: both;
        text-align: center;
        font-size: 14px;
        color: #c0c4cc;
    }

    .daily-createTime {
        text-align: right;
        margin-right: 10px;
        font-size: 12px;
        color: #c0c4cc;
    }

    .daily-title {
        color: #c0c4cc;
    }

    .daily-content {
        height: 200px;
        overflow: auto;
        padding: 5px 0;
    }

    .edit-button {
        float: right;
        margin-right: 5px;
    }
}

.add-button {
    float: right;
    margin-right: 20px;
}

.el-card__body {
    padding: 10px !important;
}
</style>